import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ChevronLeft, ChevronRight, GroupSharp, PeopleAlt } from "@material-ui/icons";
import {
  makeStyles,
  InputAdornment,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  TextField,
  Typography,
  Box,
} from "@material-ui/core";

import { Accordion } from "@material-ui/core";
import { AccordionSummary } from "@material-ui/core";
import { AccordionDetails } from "@material-ui/core";
// import Typography from '@mui/material/Typography';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@material-ui/core/Divider'
import {
  Dashboard,
  Equalizer,
  ExpandLess,
  ExpandMore,
  Group,
  GroupAdd,
  GroupWork,
  Search,
  TimerOff,
  Timeline,
  GroupWorkIcon
} from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import { useHistory, useLocation } from "react-router-dom";
import {
  ACTIVITIES,
  ALL_ACTIVITIES,
  INCOMPLETE_PUNCHES,
  MANAGE_ACTIVITY_GROUP,
  MANAGE_WORKERS,
  REPORTS,
  ALL_HIGH_DURATION_ACTIVITIES,
  ROOT,
  MANAGE_TIMESHEET,
  TRANSPORT_TRIP
} from "navigation/CONSTANTS";
import { SET_EMPTY } from "config";

import {
  selectedWorkerOnReview,
  selectedTeamOnReview,
} from "../../../redux/actions/appActions";
import { useDispatch, useSelector } from "react-redux";
import { MY_TEAM, OTHER_TEAM } from "config/CONSTANTS";
import { properCase } from "../../../utils";
import { setDrawerOpen } from "redux/actions/appActions";
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
  accordianSummary:{
    // padding: "0px",
    width: "100%",
    maxWidth: 360,
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
  MuiListItemTextPrimarySpanText :{
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    width: "150px"
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  selected: {
    color: theme.palette.primary.main,
  },
  color: {
    color: theme.grey,
  },

 
}));

export const Reportees = ({
  allWorkers,
  allPunches,
  allOtherPunches,
  selectedWorker,
  setSelectedWorker,
  isManageWorkers,
  setManageWorkers,
  isReportView,
  setReportView,
  isTimesheetView,
  setTimesheetView,
  approveForManager,
  selectedTeam,
  setSelectedTeam,
  isAllPunchView,
  setAllPunchView,
  isManageActivityGroup,
  setManageActivityGroup,
  isHighDuration,
  setHighDuration,
  isTransportationDetails,
  setTransportDetails
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const { dscDrawerOpen } = useSelector((state) => state.appConfig);
  const { pathname } = useLocation();

  const [open, setOpen] = React.useState(
    !isManageWorkers &&
      !isReportView &&
      !isManageActivityGroup &&
      INCOMPLETE_PUNCHES !== pathname &&
      ALL_HIGH_DURATION_ACTIVITIES !== pathname &&
      MY_TEAM == selectedTeam
  );
  const [openOtherTeam, setOpenOtherTeam] = React.useState(
    !isManageWorkers &&
      !isReportView &&
      !isManageActivityGroup &&
      INCOMPLETE_PUNCHES !== pathname &&
      ALL_HIGH_DURATION_ACTIVITIES !== pathname &&
      OTHER_TEAM == selectedTeam
  );
  

  const handleExpand = () => {
    // console.log("Values", pathname, dscDrawerOpen);
    // if (pathname == ALL_ACTIVITIES || pathname == ACTIVITIES) {
    expandTeam(true, !dscDrawerOpen);
    // } else {
    //   expandTeam(true);
    // }
    dispatch(setDrawerOpen(true));
  };

  const handleOtherTeamExpand = () => {
    expandTeam(false, !dscDrawerOpen);
    dispatch(setDrawerOpen(true));
  };

  const expandTeam = (isMyTeam, isOpen) => {
    let team;
    if (isMyTeam) {
      team = MY_TEAM;
      setOpenOtherTeam(false);
      let shouldOpen = isOpen ? isOpen : !open;
      setOpen(shouldOpen);
      // if (shouldOpen) handleAllPunchViewClick(null, MY_TEAM);
    } else {
      team = OTHER_TEAM;
      setOpen(false);
      let shouldOpen = isOpen ? isOpen : !openOtherTeam;
      setOpenOtherTeam(shouldOpen);
    }
    setSearchOption(SET_EMPTY);
    if (!allWorkers[team]) {
      dispatch(selectedWorkerOnReview({}));
      dispatch(selectedTeamOnReview({ team: team }));
      setSelectedTeam(team);
      setSelectedIndex(null);
      setSelectedWorker({});
      setManageWorkers(false);
    }
  };

  const [selectedIndex, setSelectedIndex] = React.useState(
    selectedWorker && selectedWorker.workerId
  );
  useEffect(() => {
    setSelectedIndex(selectedWorker && selectedWorker.workerId);
  }, [selectedWorker]);
  const [searchOption, setSearchOption] = React.useState(SET_EMPTY);
  const handleListItemClick = (event, worker, isSearch, team) => {
    if (worker) {
      setHighDuration(false);
      setManageActivityGroup(false);
      setAllPunchView(false);
      setSelectedIndex(worker.workerId);
      setSelectedWorker(worker);
      setManageWorkers(false);
      setReportView(false);
      if (isSearch) {
        setSearchOption(
          allWorkers[team][
            allWorkers[team].findIndex((option) => {
              return option.workerId === worker.workerId;
            })
          ]
        );
      } else {
        setSearchOption(SET_EMPTY);
      }
      setSelectedTeam(team);
      console.log("worker: ", worker);
      dispatch(selectedWorkerOnReview({ worker: worker }));
      dispatch(selectedTeamOnReview({ team: team }));
      history.push(ACTIVITIES);
    }
  };

  const handleManageWorkerClick = (event, team) => {
    setSelectedTeam(team);
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(true);
    setReportView(false);
    setSearchOption(SET_EMPTY);
    dispatch(selectedTeamOnReview({ team: team }));
    setManageActivityGroup(false);
    setHighDuration(false);
    history.push(MANAGE_WORKERS, { isManageWorkers: true });
  };

  const handleReportViewClick = (event , team) => {
    setSelectedTeam(team);
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(false);
    setReportView(true);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(false);
    setHighDuration(false);
    dispatch(selectedTeamOnReview({ team: team }));
    history.push(REPORTS, { isReportView: true });
  };

  const handleTransportationTripClick = (event, team) =>{
    setSelectedTeam(team);
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(false);
    setReportView(false);
    setTransportDetails(true);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(false);
    setHighDuration(false);
    dispatch(selectedTeamOnReview({ team: team }));
    history.push(TRANSPORT_TRIP, { isTransportationDetails: true });
  }

  const handleTimesheetViewClick = (event, team) => {
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(false);
    setReportView(false);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(false);
    setHighDuration(false);
    setTimesheetView(true);
    setSelectedTeam(team);
    history.push(MANAGE_TIMESHEET, { isTimesheetView: true });
    dispatch(selectedTeamOnReview({ team: team }));
  };

  const handleIncompleteViewClick = (event ,team) => {
    setSelectedTeam(team);
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(false);
    setReportView(false);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(false);
    setHighDuration(false);
    dispatch(selectedTeamOnReview({ team: team }));
    history.push(INCOMPLETE_PUNCHES);

  };

  const handleManageActivityGroupClick = (event) => {
    console.log("clicked on mag view");
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(false);
    setReportView(false);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(true);
    setHighDuration(false);
    history.push(MANAGE_ACTIVITY_GROUP, { isManageActivityGroup: true });
  };
  const handleAllPunchViewClick = (event, team) => {
    if (team === MY_TEAM) {
      setOpenOtherTeam(false);
      setOpen(true);
    } else {
      setOpen(false);
      setOpenOtherTeam(true);
    }
    setAllPunchView(true);
    setSelectedIndex(null);
    setSelectedWorker({});
    setManageWorkers(false);
    setReportView(false);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(false);
    setSelectedTeam(team);
    dispatch(selectedWorkerOnReview({ worker: {} }));
    dispatch(selectedTeamOnReview({ team: team }));
    setHighDuration(false);
    history.push(ALL_ACTIVITIES, { isAllPunchView: true });
  };

  const handleHighDurationClick = (event ,team) => {
    setSelectedTeam(team);
    console.log("clicked on highduration view");
    setAllPunchView(false);
    setSelectedIndex(null);
    setSelectedWorker({});
    setOpen(false);
    setOpenOtherTeam(false);
    setManageWorkers(false);
    setReportView(false);
    setSearchOption(SET_EMPTY);
    setManageActivityGroup(false);
    setHighDuration(true);
    dispatch(selectedTeamOnReview({ team: team }));
    history.push(ALL_HIGH_DURATION_ACTIVITIES, { isHighDuration: true });
  };

  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [expandedTeam, setExpandedTeam] = React.useState('panel2');

  const handleTeamChange = (pane2) => (event, newExpanded) => {
    setExpandedTeam(newExpanded ? pane2 : false);
  };

  const [openExpand, setOpenExpand] = React.useState(true);
  const handleExpandClick = () => {
    setOpenExpand(!openExpand);
  };

  const [openTeamExpand, setOpenTeamExpand] = React.useState(true);
  const handleExpandTeamClick = () => {
    setOpenTeamExpand(!openTeamExpand);
  };

  console.log("Other team member"+OTHER_TEAM);
  return (
    <>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        className={classes.root}
      >
        <ListItem
          button
          selected={selectedIndex === 0}
          onClick={() => history.push(ROOT)}
        >
          <ListItemIcon>
            <Dashboard />
          </ListItemIcon>
          <ListItemText
          style={{color:"black"}}
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("pgReview.tlDashboard"))}
          />
        </ListItem>
        <Divider />

        <List component="nav" className={classes.appMenu} disablePadding>
   


      <ListItem button onClick={handleExpandClick} className={classes.menuItem}>
        <ListItemIcon className={classes.menuItemIcon}>
          <PeopleAlt />
        </ListItemIcon>
        <ListItemText primary="My Team" style={{color:"black"}}/>
        {openExpand ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openExpand} >
        <Divider />
        <List>
           
        <ListItem
          key={"manageTimesheetView"}
          button
          selected={isTimesheetView && MY_TEAM === selectedTeam}
          onClick={(event) => handleTimesheetViewClick(event, MY_TEAM)}
          className={`${
            isTimesheetView && MY_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <CalendarTodayIcon />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.lblManageTimesheets"))}
          />
        </ListItem>

        <ListItem
          key={"manageWorkers"}
          button
          selected={isManageWorkers && MY_TEAM === selectedTeam}
          onClick={(event) => handleManageWorkerClick(event, MY_TEAM)}
          className={`${
            isManageWorkers && MY_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <GroupAdd />
          </ListItemIcon>
          <ListItemText
            primary={properCase(t("pgReview.tlManageWorkers"))}
            primaryTypographyProps={{ noWrap: true }}
          />
        </ListItem>
        <ListItem
          key={"ManageActivityGroup"}
          button
          selected={isManageActivityGroup}
          onClick={(event) => handleManageActivityGroupClick(event)}
          className={`${isManageActivityGroup && classes.selected}`}
        >
          <ListItemIcon>
            <GroupWork />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.titleManageActivityGroup"))}
          />
        </ListItem>

        <ListItem
          key={"incompleteView"}
          button
          selected={INCOMPLETE_PUNCHES === pathname && MY_TEAM === selectedTeam}
          onClick={(event) => handleIncompleteViewClick(event,MY_TEAM)}
          className={`${INCOMPLETE_PUNCHES === pathname   && MY_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <TimerOff />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.lblIncompleteActivities"))}
          />
        </ListItem>

        <ListItem
          key={"HighDuration"}
          button
          selected={isHighDuration && MY_TEAM === selectedTeam}
          onClick={(event) => handleHighDurationClick(event ,MY_TEAM)}
          className={`${isHighDuration   && MY_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <Timeline />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.ReviewHighDuration"))}
          />
        </ListItem>
        <ListItem
          key={"reportView"}
          button
          selected={isReportView && MY_TEAM === selectedTeam}
          onClick={(event) => handleReportViewClick(event,MY_TEAM)}
          className={`${isReportView && MY_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <Equalizer />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.tlviewDetailedActivity"))}
          />
        </ListItem>
        <ListItem
          key={"transportaion details"}
          button
          selected={isTransportationDetails && MY_TEAM === selectedTeam}
          onClick={(event) => handleTransportationTripClick(event,MY_TEAM)}
          className={`${isTransportationDetails && MY_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <LocalShippingOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.transportationDetails"))}
          />
        </ListItem>
        
        </List>
      </Collapse>
    </List>

    <Divider />



      {approveForManager && <>
        <List>
      <ListItem button onClick={handleExpandTeamClick} className={classes.menuItem}>
        <ListItemIcon className={classes.menuItemIcon}>
          <SupervisedUserCircleIcon />
        </ListItemIcon>
        <ListItemText
        classes={{primary:classes.MuiListItemTextPrimarySpanText}}
        style={{color:"black"}}>
          
        {approveForManager.managerFirstName +  " " +
            
            approveForManager.managerLastName +"'s Team"} 
            

            </ListItemText>
            {openTeamExpand ? <ExpandLess /> : <ExpandMore />}



      </ListItem>
      <Collapse in={openTeamExpand} >
        <Divider />
        <List>
           
        <ListItem
          key={"manageTimesheetView"}
          button
          selected={isTimesheetView && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleTimesheetViewClick(event, OTHER_TEAM)}
          className={`${
            isTimesheetView && OTHER_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <CalendarTodayIcon />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.lblManageTimesheets"))}
          />
        </ListItem>

        <ListItem
          key={"manageWorkers"}
          button
          selected={isManageWorkers && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleManageWorkerClick(event, OTHER_TEAM)}
          className={`${
            isManageWorkers && OTHER_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <GroupAdd />
          </ListItemIcon>
          <ListItemText
            primary={properCase(t("pgReview.tlManageWorkers"))}
            primaryTypographyProps={{ noWrap: true }}
          />
        </ListItem>

        <ListItem
          key={"incompleteView"}
          button
          selected={INCOMPLETE_PUNCHES === pathname && OTHER_TEAM=== selectedTeam}
          onClick={(event) => handleIncompleteViewClick(event,OTHER_TEAM)}
          className={`${INCOMPLETE_PUNCHES === pathname   && OTHER_TEAM === selectedTeam && classes.selected}`}
        >

          <ListItemIcon>
            <TimerOff />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.lblIncompleteActivities"))}
          />
        </ListItem>
       
  <ListItem
          key={"HighDuration"}
          button
          selected={isHighDuration && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleHighDurationClick(event ,OTHER_TEAM)}
          className={`${isHighDuration   && OTHER_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <Timeline />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.ReviewHighDuration"))}
          />
        </ListItem>
        <ListItem
          key={"reportView"}
          button
          selected={isReportView && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleReportViewClick(event,OTHER_TEAM)}
          className={`${isReportView && OTHER_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <Equalizer />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.tlviewDetailedActivity"))}
          />
        </ListItem>
        <ListItem
          key={"transportaion details"}
          button
          selected={isTransportationDetails && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleTransportationTripClick(event,OTHER_TEAM)}
          className={`${isTransportationDetails && OTHER_TEAM === selectedTeam && classes.selected}`}
        >
          <ListItemIcon>
            <LocalShippingOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.transportationDetails"))}
          />
        </ListItem>
        </List>
      </Collapse>
    </List>
        {/* <Accordion expanded={expandedTeam === 'panel2'} onChange={handleTeamChange('panel2')}  >


        <AccordionSummary
         classes={{root:classes.accordianSummary,content:classes.accordianContent}}
          expandIcon={<ExpandMore sx={{ fontSize: '0.9rem'}} />}

        > 
         <ListItem   >
         <ListItemIcon  >
           <PeopleAlt />
           </ListItemIcon>
         
     
          <Typography className={classes.root}  style={{  whiteSpace: "nowrap" ,textOverflow:"ellipsis",overflow:"hidden"}}>
      
                {approveForManager.managerFirstName +  " " +
            
            approveForManager.managerLastName +"'s Team"} 
        
               </Typography>
         </ListItem>

        </AccordionSummary>
        <AccordionDetails className={classes.root}>
          <Typography >
          
        <ListItem
          key={"manageTimesheetView"}
          button
          selected={isTimesheetView && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleTimesheetViewClick(event, OTHER_TEAM)}
          className={`${
            isTimesheetView && OTHER_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <Group />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.lblManageTimesheets"))}
          />
        </ListItem>
       
         <ListItem
          key={"manageWorkers"}
          button
          selected={isManageWorkers && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleManageWorkerClick(event, OTHER_TEAM)}
          className={`${
            isManageWorkers && OTHER_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <GroupAdd />
          </ListItemIcon>
          <ListItemText
            primary={properCase(t("pgReview.tlManageWorkers"))}
            primaryTypographyProps={{ noWrap: true }}
          />
        </ListItem>

        <ListItem
          key={"incompleteView"}
          button
          selected={isReportView && OTHER_TEAM === selectedTeam}
          onClick={(event) => handleIncompleteViewClick(event)}
          className={`${
            isReportView && OTHER_TEAM === selectedTeam && classes.selected
          }`}
        >
          <ListItemIcon>
            <TimerOff />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.lblIncompleteActivities"))}
          />
        </ListItem>

        <ListItem
          key={"HighDuration"}
          button
          selected={isHighDuration}
          onClick={(event) => handleHighDurationClick(event)}
          className={`${isHighDuration && classes.selected}`}
        >
          <ListItemIcon>
            <Timeline />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.ReviewHighDuration"))}
          />
        </ListItem>
        <ListItem
          key={"reportView"}
          button
          selected={isReportView}
          onClick={(event) => handleReportViewClick(event)}
          className={`${isReportView && classes.selected}`}
        >
          <ListItemIcon>
            <Equalizer />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={properCase(t("other.tlviewDetailedActivity"))}
          />
        </ListItem>
          </Typography>
        </AccordionDetails>
      </Accordion> */}



       </>}
       
      </List>
    </>
  );
};

const EmployeeNameMarkup = ({ firstName, lastName, empPunches }) => {
  const [fontWeightVal, setFontWeightVal] = React.useState("fontWeightRegular");
  React.useEffect(() => {
    setFontWeightVal("fontWeightRegular");
    if (empPunches.length > 0) {
      if (
        empPunches.filter(
          (item) =>
            (item.status === "new" || item.status === "edit") &&
            item.outLocalTS !== ""
        ).length > 0
      )
        setFontWeightVal("fontWeightBold");
    }
  }, [empPunches]);
  return (
    <Box
      component="span"
      fontWeight={fontWeightVal}
    >{`${firstName} ${lastName} ${
      empPunches.length > 0 ? "(" + empPunches.length + ")" : ""
    }`}</Box>
  );
};

Reportees.propTypes = {
  selectedWorker: PropTypes.object.isRequired,
  allWorkers: PropTypes.array.isRequired,
  allPunches: PropTypes.object.isRequired,
  allOtherPunches: PropTypes.object.isRequired,
  setSelectedWorker: PropTypes.func.isRequired,
  isManageWorkers: PropTypes.bool.isRequired,
  setManageWorkers: PropTypes.func.isRequired,
  isReportView: PropTypes.bool.isRequired,
  setReportView: PropTypes.func.isRequired,
  isTimesheetView: PropTypes.bool.isRequired,
  setTimesheetView: PropTypes.func.isRequired,
  approveForManager: PropTypes.func.isRequired,
  selectedTeam: PropTypes.string.isRequired,
  setSelectedTeam: PropTypes.string.isRequired,
  isAllPunchView: PropTypes.bool.isRequired,
  setAllPunchView: PropTypes.func.isRequired,
  isDSCView: PropTypes.bool.isRequired,
  setDSCView: PropTypes.func.isRequired,
  isManageActivityGroup: PropTypes.bool.isRequired,
  setManageActivityGroup: PropTypes.func.isRequired,
  setHighDuration: PropTypes.func.isRequired,
  isHighDuration: PropTypes.func.isRequired,
  isTransportationDetails:PropTypes.func.isRequired,
  setTransportDetails:PropTypes.func.isRequired
};

export default Reportees;
